import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class AnalisisDemandaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    ObtenerSegunProducto(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($empresa_rut: Decimal, $sucursalCodigo: Decimal, $listaFormatos: [String], $producto_codigo: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          analisis_demanda {
            obtenerSegunProducto(rutEmpresa: $empresa_rut, sucursalCodigo: $sucursalCodigo, listaFormatos: $listaFormatos, producto_codigo: $producto_codigo, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  cantidad_requerida
                  diferencia_con_stock
                  documento_no_tributario_folio
                  documento_no_tributario_tipo_dte_codigo
                  empresa_rut
                  estado
                  fecha_analisis
                  formato_codigo
                  idanalisis
                  producto_codigo
                  stock_actual
                  sucursal_codigo
                  cliente_proveedor_rut
                  nombrecliente
                  estadocodigo
                  nombreVendedor
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.analisis_demanda.obtenerSegunProducto;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerCantidadEnQuiebre(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $productoCodigo: Decimal, $formatoCodigo: String) {
          analisis_demanda {
            obtenerCantidadEnQuiebre(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, productoCodigo: $productoCodigo, formatoCodigo: $formatoCodigo) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                cantidad_requerida
                producto_codigo
                formato_codigo
                nombreProducto
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.analisis_demanda.obtenerCantidadEnQuiebre;
            callback({ mensajes, respuesta });
        });
    }
    obtenerAnalisisExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $obtenerResumen: Boolean) {
          analisis_demanda {
            obtenerAnalisisExcel(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, obtenerResumen: $obtenerResumen) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.analisis_demanda.obtenerAnalisisExcel;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDatosGeneralesAnalisis(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal) {
          analisis_demanda {
            obtenerDatosGeneralesAnalisis(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                fecha_analisis
                fecha_inicio_busqueda
                fecha_termino_busqueda
                nombreBodega
                nroPedidos
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.analisis_demanda.obtenerDatosGeneralesAnalisis;
            callback({ mensajes, respuesta });
        });
    }
    cambiarEstadoProcesoAnalisis(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($fechaEmision: String, $rutEmpresa: Decimal, $sucursalCodigo: Decimal, $rutUsuario: Decimal, $folios: [Decimal]) {
          analisis_demanda {
            cambiarEstadoProcesoAnalisis(fechaEmision: $fechaEmision, rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, rutUsuario: $rutUsuario, folios: $folios) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                fecha_analisis
                fecha_inicio_busqueda
                fecha_termino_busqueda
                nombreBodega
                nroPedidos
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.analisis_demanda.cambiarEstadoProcesoAnalisis;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltroQuiebres(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rut_empresa: Decimal, $fecha_inicio_busqueda: Date, $fecha_termino_busqueda: Date) {
          analisis_demanda {
            obtenerSegunFiltroQuiebres(
              filtro: {
                exacto: {
                  rut_empresa: $rut_empresa,
                  fecha_inicio_busqueda: $fecha_inicio_busqueda,
                  fecha_termino_busqueda: $fecha_termino_busqueda
                }
              }
            ) {
              mensajes {
                codigo
                contexto
                tipo
                texto
                __typename
              }
              respuesta {
                registros {
                  cantidad_requerida
                  estado
                  producto_codigo
                  formato_codigo
                  fecha_inicio_busqueda
                  fecha_termino_busqueda
                  cantidad_atendida
                  nombreProducto
                  sku
                  documento_no_tributario_folio
                  cliente_proveedor_rut
                  nombrecliente
                  nombreVendedor
                  nombreComuna
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.analisis_demanda.obtenerSegunFiltroQuiebres;
            callback({ mensajes, respuesta });
        });
    }
    obtenerHistoricoQuiebresAgrupado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rut_empresa: Decimal, $sucursal_codigo: Decimal, $fecha_inicio_busqueda: Date, $fecha_termino_busqueda: Date, $sku: String, $producto_codigo: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          analisis_demanda {
            obtenerHistoricoQuiebresAgrupado(
              filtro: {
                exacto: {
                  rut_empresa: $rut_empresa,
                  sucursal_codigo: $sucursal_codigo,
                  fecha_inicio_busqueda: $fecha_inicio_busqueda,
                  fecha_termino_busqueda: $fecha_termino_busqueda,
                  sku: $sku,
                  producto_codigo: $producto_codigo
                }
              }
              paginaActual: $paginaActual
              cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
            ) {
              mensajes {
                codigo
                contexto
                tipo
                texto
                __typename
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  sku
                  nombreProducto
                  demandaCantidad
                  demandaFraccion
                  demandaAtendidaCantidad
                  demandaAtendidaFraccion
                  quiebreCantidad
                  quiebreFraccion
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.analisis_demanda.obtenerHistoricoQuiebresAgrupado;
            callback({ mensajes, respuesta });
        });
    }
    obtenerHistoricoExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
       query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $obtenerResumen: Boolean, $fechaDesde: String, $fechaHasta: String, $sku: String, $producto_codigo: Decimal) {
        analisis_demanda {
          obtenerHistoricoExcel(
            rutEmpresa: $rutEmpresa
            sucursalCodigo: $sucursalCodigo
            obtenerResumen: $obtenerResumen
            fechaDesde: $fechaDesde
            fechaHasta: $fechaHasta
            sku: $sku
            producto_codigo: $producto_codigo
          ) {
            mensajes {
              codigo
              contexto
              tipo
              texto
            }
            respuesta
          }
        }
      }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.analisis_demanda.obtenerHistoricoExcel;
            callback({ mensajes, respuesta });
        });
    }
}
AnalisisDemandaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnalisisDemandaService_Factory() { return new AnalisisDemandaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: AnalisisDemandaService, providedIn: "root" });
